import React, {Component} from 'react';


class News extends Component {
    render() {
        return (
            <div>
                <h1 className="f2 yatra tc mv4"> <span className="light-red">News</span><span className="light-green">sweN</span><span className="light-blue">News</span><span className="light-red">sweN</span><span className="light-green">News</span><span className="light-blue">sweN</span></h1>
                <div className="bg-black-70 shadow-4-l b--dashed b--orange w-80 center"> 
                    <ul className="yatra">
                        <li className="ma2"><span className="a">30.07.2018</span> <span className="b">Update: New works added to "Things I Did", PIY Scores, Listen, new social media links, edits in existing pages.</span></li>
                        <li className="ma2"><span className="a">30.07.2018</span> <span className="b">Website is online!</span></li>
                    </ul>

                </div>
            </div>
        )
    }
}





export default News;


// WEBPACK FOOTER //
// ./src/components/news.jsx